export const faqList = [
  {
    id: "q1",
    question: "디즈니+는 어떤 서비스인가요?",
    answer:
      "디즈니+는 디즈니, 픽사, 마블, 스타워즈, 내셔널지오그래픽, Hulu 브랜드의 콘텐츠를 스트리밍으로 감상할 수 있는 서비스입니다.",
  },
  {
    id: "q2",
    question: "디즈니+에서는 어떤 콘텐츠를 볼 수 있나요?",
    answer:
      "다음과 같은 콘텐츠를 시청할 수 있습니다.\n- 최신 공개 영화와 인기 시리즈\n- 디즈니, 픽사, 마블, 스타워즈 오리지널\n- 가족, 액션, 코미디, 다큐멘터리 장르\n- 시청 기록과 취향을 반영한 추천 작품",
  },
  {
    id: "q3",
    question: "어떤 기기에서 시청할 수 있나요?",
    answer:
      "모바일 기기, 태블릿, 웹 브라우저, 게임 콘솔, 스마트 TV 등 다양한 환경에서 이용할 수 있습니다.",
  },
  {
    id: "q4",
    question: "구독 요금은 어떻게 되나요?",
    answer:
      "디즈니+ 스탠다드는 월 9,900원, 프리미엄은 월 13,900원에 이용할 수 있으며 연간 상품도 선택할 수 있습니다.",
  },
  {
    id: "q5",
    question: "디즈니+ 번들 요금제는 무엇인가요?",
    answer:
      "디즈니+, 제휴 서비스 조합으로 구성된 번들 상품을 통해 개별 구독 대비 더 합리적인 가격으로 이용할 수 있습니다.",
  },
  {
    id: "q6",
    question: "번들 상품은 어떻게 이용하나요?",
    answer:
      "원하는 번들 유형을 선택해 결제하면 각 서비스의 이용 조건에 따라 계정을 연동해 사용할 수 있습니다.",
  },
];
